<div id="home-filiz-irrigation-info">
  @if (hasAnyDevice) {
    @if (!upcomingIrrigationLoading) {
      <div class="header">
        <span class="title">{{ 'doktar_app.home.filiz_irrigation.title' | translate }}</span>
      </div>
      @if (!fetchingError) {
        @if (selectedPlantationForFilizIrrigation?.moistureByDepthList?.length > 0) {
          <div class="plantation-selection">
            <span class="information">
              {{ 'doktar_app.home.filiz_irrigation.showing_data_for' | translate }}
            </span>
            <div class="select-box">
              <dk-home-plantation-select
                #filizIrrigationSelect
                [selectablePlantations]="selectablePlantationsForFilizIrrigation"
                [selectedPlantation]="selectedPlantationForFilizIrrigation"
                (onSelectPlantation)="onSelectPlantationForFilizIrrigation($event)" />
            </div>
          </div>
          <div class="my-2">
            <p class="latest-updates-date">
              {{ 'doktar_app.services.agroclimate.latest_updates_date' | translate }}
              {{ selectedPlantationForFilizIrrigation?.date  | luxonFormat:'dd/MM/yyyy HH:mm': ('UTC'+ plantationService.selectedPlantation.offSet) }} (UTC{{ plantationService.selectedPlantation.offSet }})
            </p>
            <p class="device-asset-id">
              <i class="ph ph-barcode icon"></i>
              <span class="asset-id" [dkClipboard]="selectedPlantationForFilizIrrigation.assetId || ''" (click)="$event.stopPropagation()">{{ selectedPlantationForFilizIrrigation?.assetId | truncate:4 }}</span>
            </p>
          </div>
          <div class="sensor-view">
            @for (item of selectedPlantationForFilizIrrigation?.moistureByDepthList; track item; let index = $index) {
              <div class="sensor-item">
                <div class="sensor-item-content">
                  <span class="depth">
                    {{ item.depthName }}
                    <span class="depth-defer">
                      {{ ' ' + ('doktar_app.home.filiz_irrigation.depth_lower' | translate) }}
                    </span>
                  </span>
                  <span class="information">
                    @if (getStatusSpecifications(item)?.value) {
                      <span class="status-label">{{ getStatusSpecifications(item)?.value | translate }},</span>
                    }
                    <span>{{ item.displayCurrentValue }}</span>
                    <span>{{ ' • ' + item.temperatureDisplayText }}</span>
                  </span>
                </div>
                <div
                  class="sensor-item-bar"
                  [class.last]="index == selectedPlantationForFilizIrrigation?.moistureByDepthList?.length - 1">
                  <!-- Threshold lines positioned above progress bar -->
                  <div class="threshold-lines-container">
                    <span class="threshold-line" [style.left]="item.minThreshold * 1.6 + 1 + '%'"></span>
                    <span class="threshold-line" [style.left]="item.maxThreshold * 1.6 + 1 + '%'"></span>
                    <span class="threshold-line" [style.left]="item.optimalMaxThreshold * 1.6 + 1 + '%'"></span>

                    @if (index === selectedPlantationForFilizIrrigation?.moistureByDepthList?.length - 1) {
                      <span class="line-caption" [style.left]="item.minThreshold * 1.6 + 1 + '%'">
                        {{ 'doktar_app.common.min' | translate }}: {{ item.minThreshold | number }}%
                      </span>
                      <span class="line-caption" [style.left]="item.optimalMaxThreshold * 1.6 + 1 + '%'">
                        {{ 'doktar_app.common.max' | translate }}: {{ item.optimalMaxThreshold | number }}%
                      </span>
                      <span class="line-caption" [style.left]="item.maxThreshold* 1.6 + 1 + '%'">
                        {{ 'doktar_app.common.saturated_short' | translate }}: {{ item.maxThreshold | number }}%
                      </span>
                    }
                  </div>

                  <p-progressbar
                    [showValue]="false"
                    [value]="item.currentValue"
                    [style]="getProgressBarStyles(item)"
                    [ngClass]="'soil-status-progressbar'"></p-progressbar>
                </div>
              </div>
            }
          </div>
        } @else {
          no data
        }
      } @else {
        <widget-info-box
          [isErrorState]="true"
          [title]="'doktar_app.home.warnings.not_load_filiz_info_title' | translate"
          [description]="
            'doktar_app.home.warnings.not_load_filiz_info_description'
              | translate
          "
          (primaryButtonClick)="getFilizIrrigationPlantations()"></widget-info-box>
      }
    } @else {
      <p-skeleton width="100%" height="100%" styleClass="mb-2" />
    }
  } @else {
    <div class="irrigation-info-no-premium">
      <div class="no-premium-irrigation card-image">
        <img src="/assets/images/no-premium/irrigation.png" alt="" />
      </div>
      <div class="content">
        <span class="title">{{ 'doktar_app.home.filiz_irrigation.add_device_title' | translate }}</span>
        <span class="description">{{ 'doktar_app.home.filiz_irrigation.add_device_description' | translate }}</span>
      </div>
      <div class="actions">
        <dk-button
          [label]="'doktar_app.communications.home.request_callback' | translate"
          severity="secondary"
          (onClick)="requestCallbackEvent.emit()"></dk-button>
        <dk-button
          [label]="'doktar_app.account.devices.add_device_button_title_short' | translate"
          severity="primary"
          (onClick)="routeToDevices()"></dk-button>
      </div>
    </div>
  }
</div>
